module.exports = __webpack_public_path__ + "img/skype.002020eb.svg";